













import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class SideBarGroup extends Vue {
  @Prop() public title!: string;
  @Prop() public accordion!: string;

  public opened: boolean = false;
  public icon: string = 'arrow_right';

  public apend(item: Components.SideBarItem){
    //グループ内にターゲットがある場合はオープンすうｒ。
    if (this.$route.fullPath == item.to){
      this.$nextTick(()=>this.collapse());
    }
  }

  @Watch('opened')
  public onValueChange(newValue: boolean, oldValue: boolean): void {
    if (this.opened) {
      this.icon = 'arrow_drop_down';
    } else {
      this.icon = 'arrow_right';
    }
  }

  public collapse() {
    this.opened = !this.opened;
    if (this.opened) {
      this.icon = 'arrow_drop_down';
    } else {
      this.icon = 'arrow_right';
    }
  }
}
